<template>
  <div id="email-auth-view">
    <header>
      <div class="icon">
        <h1>Shadow</h1>
      </div>
      <h2>Launching Shadow</h2>
      <p>Click "Open Shadow" to launch the desktop app.</p>
    </header>
    <main>
      <div class="btn-group-wrap">
        <button id="btn-open-shadow" @click="open">Open Shadow</button>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "EmailAuthView",
  data() {
    return {};
  },
  async mounted() {
    if (
      document.referrer.includes("https://taperlabs-shadow.firebaseapp.com")
    ) {
      this.open();
    } else {
      alert("This is not a valid access.");
      this.cancel();
    }
  },
  methods: {
    cancel() {
      location.href = "https://shadow.do";
    },
    open() {
      if (
        !document.referrer.includes("https://taperlabs-shadow.firebaseapp.com")
      )
        return;
      location.href = "shadow://auth?emailLink=" + encodeURI(window.location);
    },
  },
};
</script>

<style>
body:has(#email-auth-view) {
  background: #151515;
  color: #fff;
}
</style>

<style scoped>
#email-auth-view {
  max-width: 720px;
  margin: 0 auto;
  padding: 5.587% 6.9835%;
}

header {
  margin-bottom: 60px;
  text-align: center;
}

header .icon {
  margin-bottom: 60px;
}

header .icon h1 {
  width: 120px;
  height: 31.2px;
  text-indent: -9999px;
  margin: 0 auto;
  background-image: url("@/assets/img/logo.png");
  background-size: cover;
}

header h2 {
  margin-bottom: 30px;
  font-size: 32px;
  font-weight: 600;
}

header p {
  font-size: 18px;
  font-weight: 300;
  color: #ccc;
}

button {
  position: relative;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  padding: 0 12px;
  border: 1px solid #777;
  border-radius: 5px;
  color: #aaa;
  background-color: #1d2021;
  cursor: pointer;
  text-align: center;
}

div.btn-group-wrap {
  text-align: center;
}

div.btn-group-wrap button {
  font-size: 16px;
}

#btn-open-shadow {
  width: 240px;
  height: 40px;
  border: 1px solid #d65d0e;
  background: #d65d0e;
  color: #fff;
  font-weight: 600;
}
</style>
